function Header({title}) {
  const image="./bannerfile.png";
  return (
    <header className="w-full bg-gradient-to-r from-red-500 via-yellow-500 to-blue-500 flex items-center justify-center text-white text-center p-1">
      <h1 className="text-xs sm:text-sm md:text-xl">ADMIN APP-GURUKUL SENIOR SECONDARY SCHOOL</h1>
    </header>
  )
}

export default Header